import {
    SETTOKEN, GETORDERS, GETSELECTEDORDER, SETERROR, SETORDERCOUNT, LOGOUT, GETORDERHISTORY, SETISLOADING
    , SETDEVICETOKEN
} from "../actionTypes";
import axios from './axios';

export const setToken = (token) => ({
    type: SETTOKEN,
    payload: token
})


export const getOrder = (orderId) => async (dispatch, getState) => {
    dispatch({
        type: SETISLOADING
    })
    const state = getState();
    const token = state.user.token;
    const res = await axios.post("user/order", {
        merchant_id: state.restaurant.merchant_id,
        order_id: orderId,
        client_token: token
    })

    if (res.data.code == 2) {
        dispatch({
            type: SETERROR,
            payload: res.data.msg
        })
    }

    if (res.data.code == 1) {
        dispatch({
            type: GETSELECTEDORDER,
            payload: res.data.details
        })
    }
}

export const removeUserError = () => ({
    type: SETERROR,
    payload: ""
})

export const getOrders = () => async (dispatch, getState) => {
    const state = getState();
    const token = state.user.token;
    const res = await axios.post("user/orders", {
        merchant_id: state.restaurant.merchant_id,
        client_token: token
    })

    if (res.data.code == 2) {
        dispatch({
            type: SETERROR,
            payload: res.data.msg
        })
    }

    if (res.data.code == 1) {
        dispatch({
            type: GETORDERS,
            payload: res.data.details
        })
    }
}


export const getOrderCount = () => async (dispatch, getState) => {
    const state = getState();
    const token = state.user.token;
    const order_id = state.cart.orderid;
    const res = await axios.post("order/ordercount", {
        token: token,
        order_id: order_id
    })

    if (res.data.code == 2) {
        dispatch({
            type: SETERROR,
            payload: res.data.msg
        })
    }

    if (res.data.code == 1) {
        dispatch({
            type: SETORDERCOUNT,
            payload: res.data.details
        })
    }
}

export const logOut = () => {
    localStorage.removeItem("token");
    return {
        type: LOGOUT
    }
}


export const orderHistory = () => async (dispatch, getState) => {
    const state = getState();
    const token = state.user.token;
    const order_id = state.cart.orderid;
    const res = await axios.post("user/orders", {
        client_token: token,
        order_id: order_id
    })
    if (res.data.code == 1) {
        dispatch({
            type: GETORDERHISTORY,
            payload: res.data.details.orders
        })
    }

}


export const setDeviceToken = (token) => async (dispatch, getState) => {
    const state = getState();
    const userToken = state.user.token;
    const lastDeviceToken = state.user.deviceToken;
    if (lastDeviceToken != token) {
        const res = await axios.post("/user/addtoken", {
            token: userToken,
            device_token: token,
            merchant_id: state.restaurant.merchant_id
        })
        dispatch({
            type: SETDEVICETOKEN,
            payload: token
        })
    }
}


